import axiosInstance from '../app/axios';
import DefaultPaginationProps from '../propInterfaces/defaultPaginationProps';
import AutoCompleteDTO from '../shared/dtos/autoCompleteDTO';
import UserDTO from '../shared/dtos/userDTO';
import UserProfileDTO from '../shared/dtos/userProfileDTO';
import { createColumnFilterValuesFetcher } from './columnFilterApi';
import PATHS from './paths';

export const AutoCompleteUser = async (query: AutoCompleteDTO) => {
  const result = await axiosInstance.get(
    `${PATHS.AUTOCOMPLETE_USER}?firstName=${query.firstName}&lastName=${query.lastName}&mobile=${query.mobile}&email=${query.email}`,
  );

  return result.data;
};

export const GetUserList = async ({
  page,
  take,
  search: searchText,
  columnFilters,
}: DefaultPaginationProps) => {
  const filtersQuery =
    columnFilters && Object.keys(columnFilters).length
      ? `&filters=${encodeURIComponent(JSON.stringify(columnFilters))}`
      : "";

  const result = await axiosInstance.post(
    `${PATHS.GET_USERS}search/?page=${page}&take=${take}${filtersQuery}`,
    {
      search: searchText ?? "",
    },
  );

  return result.data;
};

export const GetUserColumnFilterValues = createColumnFilterValuesFetcher(
  PATHS.GET_USERS,
);

export const GetUserById = async (userId: number) => {
  const result = await axiosInstance.get(
    `${PATHS.GET_ADMIN_USERS}${userId}`,
  );

  return result.data;
};

export const DeleteUser = async (userId: number) => {
  const result = await axiosInstance.delete(
    `${PATHS.GET_ADMIN_USERS}${userId}`,
  );

  return result.data;
};

export const UpdateUserPassword = async (userId: number, password: string) => {
  const result = await axiosInstance.patch(
    `${PATHS.GET_USERS}${userId}/password`,
    { password: password },
  );

  return result.data;
};

export const updateUser = async (userId: number, user: UserProfileDTO) => {
  const result = await axiosInstance.patch(
    `${PATHS.GET_ADMIN_USERS}${userId}/profile`,
    { user },
  );

  return result.data;
};

export const postUserAsync = async (user: UserProfileDTO) => {
  const result = await axiosInstance.post(`${PATHS.GET_ADMIN_USERS}`, {
    firstName: user.firstName,
    lastName: user.lastName,
    mobile: user.mobile,
    email: user.email,
    password: user.password,
    loginBy: user.loginBy,
    deviceType: user.deviceType,
    paymentMode: user.paymentMode,
    departmentId: user.departmentId,
  });

  return result.data;
};

export const updateUserManager = async (
  id: number | null | undefined,
  userType: boolean,
) => {
  return await axiosInstance.patch(`admin/users/${id}/usertype`, { userType });
};

export const updateUserOfferExtraTrip = async (
  id: number | null | undefined,
  offerExtraTrip: boolean,
) => {
  return await axiosInstance.patch(`admin/users/${id}/offerExtraTrip`, {
    offerExtraTrip,
  });
};

export const getCompanyUsers = async ({
  adminId
}: DefaultPaginationProps): Promise<UserDTO[]> => {
  const result = await axiosInstance.get(
    `${PATHS.GET_ADMIN_USERS}company/${adminId}`,
  );

  return result.data;
};
